export default __webpack_public_path__ + "static/media/bisrat-rapid-hackathon.149e5ecf.png";